export default __webpack_public_path__ + "static/media/violet.3518ae0d.png";